module.exports = __webpack_public_path__ + "static/img/last.833ed41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/buchong/last.png
// module id = qfGM
// module chunks = 1